import { emptyNumberAsUndefinedTransform } from './empty-number-as-undefined.transform'
import { emptyStringAsUndefinedTransform } from './empty-string-as-undefined.transform'

export const setupValidation = () => {
  emptyNumberAsUndefinedTransform()
  emptyStringAsUndefinedTransform()
}
